/** Max combined file size for all document image uploads in one generate action. */
export const DOCUMENT_UPLOAD_MAX_TOTAL_BYTES = 15 * 1024 * 1024;

export function formatUploadMegabytes(bytes) {
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function estimateDataUrlBytes(dataUrl) {
  if (!dataUrl || typeof dataUrl !== 'string') {
    return 0;
  }
  const comma = dataUrl.indexOf(',');
  const base64 = comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
  const trimmed = base64.replace(/\s/g, '');
  if (!trimmed) {
    return 0;
  }
  const padding = trimmed.endsWith('==') ? 2 : trimmed.endsWith('=') ? 1 : 0;
  return Math.max(0, Math.floor((trimmed.length * 3) / 4) - padding);
}

export function totalFileMapBytes(fileSizesByKey = {}) {
  if (!fileSizesByKey || typeof fileSizesByKey !== 'object') {
    return 0;
  }
  return Object.values(fileSizesByKey).reduce(
    (sum, size) => sum + (typeof size === 'number' && size > 0 ? size : 0),
    0
  );
}

/** @deprecated use totalFileMapBytes for multipart uploads */
export function totalSelectionBytes(selections, fileSizesByKey = {}) {
  return totalFileMapBytes(fileSizesByKey);
}

export function uploadLimitErrorMessage(totalBytes) {
  return `Total image size (${formatUploadMegabytes(totalBytes)}) exceeds the ${formatUploadMegabytes(DOCUMENT_UPLOAD_MAX_TOTAL_BYTES)} limit. Remove or replace an image.`;
}
